export const firebaseConfig = {
  apiKey: 'AIzaSyDVUqzPtOSXJ5FbXYnG448e2CXd3tosUo0',
  authDomain: 'app-android-nova.firebaseapp.com',
  databaseURL: 'https://app-android-nova.firebaseio.com',
  projectId: 'app-android-nova',
  storageBucket: 'app-android-nova.appspot.com',
  messagingSenderId: '202996681746'
};
